import { customizeError, getResponseData } from "../helpers/_functions";
import http from "../http-common";
import BaseService from "./base.service";

class AgendaModelService extends BaseService {
  constructor() {
    super("agenda-model");
  }

  // Créer un modèle d'agenda
  // createAgendaModel(data) {
  //   return http
  //     .post(`${this.path}/create`, data)
  //     .then((response) => getResponseData(response))
  //     .catch((err) => Promise.reject(customizeError(err)));
  // }

  // Liste tous les modèles
  // getAllAgendaModels(params = {}) {
  //   return http
  //     .get(`${this.path}/list`, { params })
  //     .then((response) => getResponseData(response))
  //     .catch((err) => Promise.reject(customizeError(err)));
  // }

  // Récupère un modèle par ID
  // getAgendaModelById(id) {
  //   return http
  //     .get(`${this.path}/getById/${id}`)
  //     .then((response) => getResponseData(response))
  //     .catch((err) => Promise.reject(customizeError(err)));
  // }

  // Met à jour un modèle par ID
  // updateAgendaModel(id, data) {
  //   return http
  //     .put(`${this.path}/update/${id}`, data)
  //     .then((response) => getResponseData(response))
  //     .catch((err) => Promise.reject(customizeError(err)));
  // }

  // Supprime un modèle par ID
  // deleteAgendaModel(id) {
  //   return http
  //     .delete(`${this.path}/delete/${id}`)
  //     .then((response) => getResponseData(response))
  //     .catch((err) => Promise.reject(customizeError(err)));
  // }

  // Suppression multiple
  deleteManyAgendaModels(filter) {
    return http
      .post(`${this.path}/deleteMany`, filter)
      .then((response) => getResponseData(response))
      .catch((err) => Promise.reject(customizeError(err)));
  }
}

export default new AgendaModelService();
